import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=19d92f2e&"
import script from "./record-list.vue?vue&type=script&lang=js&"
export * from "./record-list.vue?vue&type=script&lang=js&"
import style0 from "./record-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports